module.exports = __webpack_public_path__ + "img/rz_icon_2.ccd45ca1.png";